module.exports = __webpack_public_path__ + "img/quanu.576a4414.jpg";